// Osklen-grade atmosphere plate: full-bleed editorial image with restrained overlay.
// Used as a quiet transition between Manifesto and MACD — institutional, not promotional.
export const Atmosphere = () => {
  return (
    <section
      data-testid="atmosphere-section"
      className="relative w-full h-[80vh] md:h-screen min-h-[600px] overflow-hidden bg-[#0a0a0a]"
    >
      <img
        src="https://customer-assets.emergentagent.com/job_oasys-academy/artifacts/u7nn6akt_Design%20sem%20nome%20%281%29.png"
        alt="Sala de aula da Oasys Academy — formação real em andamento"
        className="absolute inset-0 w-full h-full object-cover object-center"
        style={{ filter: "contrast(1.05) saturate(0.82) brightness(0.82)" }}
      />
      {/* Premium treatment overlays — preserve yellow chairs, ensure text legibility */}
      <div className="absolute inset-0 bg-[#0a0a0a]/35" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/45" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-transparent to-black/15" />

      <div className="relative h-full max-w-[1400px] mx-auto px-6 md:px-10 flex items-center py-16 md:py-24">
        <div className="max-w-3xl reveal">
          <h2 className="font-display text-3xl md:text-5xl lg:text-[3.6rem] leading-[1.08] tracking-tight text-white">
            Sala de aula como{" "}
            <em className="italic text-[#f4c542]">laboratório.</em>
            <br />
            Profissional como autor da própria carreira.
          </h2>

          <div className="mt-10 md:mt-12 max-w-xl text-base md:text-lg leading-[1.7] text-white/80 space-y-4">
            <p>
              A Academy não acontece em palco. Acontece em laboratório.
            </p>
            <p>
              É onde o profissional aprende a ler, testar, decidir e
              construir crescimento.
            </p>
            <p>Um espaço de presença, repertório e método.</p>
          </div>
        </div>
      </div>
    </section>
  );
};
